import {Inject, Injectable} from '@angular/core';
import { CplRequestItem } from '../model/cpl-request-item.model';
import { CplUserRequest } from '../model/cpl-user-request.model';
import { CplStartUserRequest } from '../model/cpl-start-user-request.model';
import { CplChangeUserRequestManager } from '../model/cpl-change-user-request-manager.modal';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BaseApi, BASE_URL } from '@edl-development/edl-common';

@Injectable()
export class UserRequestApi extends BaseApi {
    constructor(
        @Inject(BASE_URL) private baseUri: string,
        private http: HttpClient
    ) {
        super();
    }

    startUserRequest(requestItem: CplRequestItem) {
        return this.http.post(this.baseUri + '/UserRequest', requestItem);
    }
    startUserRequestForOtherUser(data: CplStartUserRequest) {
        return this.http.post(this.baseUri + '/UserRequest/StartForOtherUser', data);
    }
    changeUserRequestManager(data: CplChangeUserRequestManager) {
        return this.http.post(this.baseUri + '/UserRequest/ChangeUserRequestManager', data, { responseType: 'text' });
    }
    getUserRequestHistory(requestID: string,offset: number, limit: number, orderBy: string, ascending: boolean, searchBy: string, status: number, tag: number) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('orderBy', this.convertParam(orderBy))
            .append('ascending', String(ascending))
            .append('searchBy', this.convertParam(searchBy))
            .append('status', String(status))
            .append('tag', String(tag));

        return this.http.get(this.baseUri + '/UserRequest/history/' + requestID, {
            params
        });
    }
    getUserRequest(userRequestID: string) {
        return this.http.get(this.baseUri + '/UserRequest/' + userRequestID);
    }
 
    getUserRequestsForItem({ 
        requestId,  
        offset, 
        limit, 
        status, 
        orderBy, 
        ascending, 
        searchBy, 
        act48Status,
        approverUserId,
        groupIds
    } : { 
        requestId: string,  
        offset: number, 
        limit: number, 
        status: number, 
        orderBy?: string, 
        ascending?: boolean, 
        searchBy?: string, 
        act48Status?: number,
        approverUserId?: string,
        groupIds?: string[]
    }) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('orderBy', this.convertParam(orderBy))
            .append('ascending', String(ascending))
            .append('searchBy', this.convertParam(searchBy))
            .append('status', String(status))
            .append('act48Status', String(act48Status))
            .append('approverUserId', approverUserId ? String(approverUserId) : '')
            .append('groupIds', this.convertArrayParam(groupIds));

        return this.http.get(this.baseUri + '/UserRequests/' + requestId , {
            params
        });
    }
    submitForVerification(userRequest: CplUserRequest) {
        return this.http.post(this.baseUri + '/UserRequest/submitForVerification', userRequest);
    }
    archiveRequestAsTargetUser(userRequest: CplUserRequest) {
        return this.http.post(this.baseUri + '/UserRequest/TargetUser/archive', userRequest, { responseType: 'text' });
    }
    archiveRequestAsSupervisor(userRequestId: string) {
        return this.http.post(this.baseUri + '/UserRequest/Supervisor/archive/' + userRequestId, { responseType: 'text' });
    }
    bulkArchiveRequestAsSupervisor(userRequestIds: string[]) {
        return this.http.post(this.baseUri + '/UserRequest/Supervisor/archive/bulk', userRequestIds);
    }

    activateRequestAsTargetUser(userRequest: CplUserRequest) {
        return this.http.post(this.baseUri + '/UserRequest/TargetUser/activate', userRequest, { responseType: 'text' });
    }
    activateRequestAsSupervisor(userRequest: CplUserRequest) {
        return this.http.post(this.baseUri + '/UserRequest/Supervisor/activate', userRequest, { responseType: 'text' });
    }
    cancelRequest(userRequest: CplUserRequest) {
        return this.http.post(this.baseUri + '/UserRequest/cancel', userRequest);
    }
    deleteRequest(userRequest: CplUserRequest) {
        return this.http.post(this.baseUri + '/UserRequest/delete', userRequest, { responseType: 'text' });
    }
    duplicateRequest(userRequestID: string) {
        return this.http.get(this.baseUri + '/UserRequest/duplicate/' + userRequestID);
    }
    getMyRequests(offset: number, limit: number, orderBy: string, ascending: boolean, searchBy: string, status: number, tag: number) {
        const params = new HttpParams()
            .append('offset', String(offset))
            .append('limit', String(limit))
            .append('orderBy', this.convertParam(orderBy))
            .append('ascending', String(ascending))
            .append('searchBy', this.convertParam(searchBy))
            .append('status', String(status))
            .append('tag', String(tag));

        return this.http.get(this.baseUri + '/UserRequest/MyRequests', {
            params
        });
    }
    getUsersWhoHaveSubmittedRequestItem(requestItemID:string) {
        return this.http.get(this.baseUri + '/UserRequest/usersForItem/' + requestItemID);
    }
}